const ruleFlag = {
    NON_DELETABLE : 1,

    NON_RENAMEABLE : 2

};

angular.module('gw-um-j2js')
    .constant('ruleFlag', ruleFlag);